import { BusinessFormFields } from '@/types/businesses';

export const blankBusinessMember = {
  consumer: '',
  ownershipPercentage: '',
  title: '',
  isControlPerson: false,
};

export const initialBusinessForm: BusinessFormFields = {
  uuid: '',
  name: '',
  dbaName: '',
  legalStructure: '',
  tin: '',
  confirmTin: '',
  company: '',
  advisors: [],
  currentAddress: {
    line1: '',
    line2: '',
    city: '',
    state: '',
    postalCode: '',
  },
  sameMailingAddress: true,
  mailingAddress: {
    line1: '',
    line2: '',
    city: '',
    state: '',
    postalCode: '',
  },
  members: [blankBusinessMember],
};
